var SocketRoomTypes = /* @__PURE__ */ ((SocketRoomTypes2) => {
  SocketRoomTypes2["moveIn"] = "move-in";
  SocketRoomTypes2["scaTransaction"] = "sca-transaction";
  SocketRoomTypes2["payment"] = "payment";
  SocketRoomTypes2["billingInfoUpdate"] = "billing-info-update";
  SocketRoomTypes2["reservationFee"] = "reservation-fee";
  return SocketRoomTypes2;
})(SocketRoomTypes || {});
var ScaTransactionTypes = /* @__PURE__ */ ((ScaTransactionTypes2) => {
  ScaTransactionTypes2["moveIn"] = "move-in";
  ScaTransactionTypes2["payment"] = "payment";
  ScaTransactionTypes2["billingInfoUpdate"] = "billing-info-update";
  return ScaTransactionTypes2;
})(ScaTransactionTypes || {});
var ScaApplicationViews = /* @__PURE__ */ ((ScaApplicationViews2) => {
  ScaApplicationViews2["boxshop"] = "boxshop";
  ScaApplicationViews2["moveIn"] = "move-in";
  ScaApplicationViews2["reservation"] = "reservation-with-fee";
  ScaApplicationViews2["standalone"] = "standalone";
  ScaApplicationViews2["tenantAccounts"] = "tenant-accounts";
  return ScaApplicationViews2;
})(ScaApplicationViews || {});
export {
  ScaApplicationViews,
  ScaTransactionTypes,
  SocketRoomTypes
};
//# sourceMappingURL=sockets.mjs.map